import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { dispatchesApi } from '@/api/dispatches.api';
import { extractErrorMessage } from '@/lib/errors';
import type { DispatchStatus } from '@/types/api.types';
export type { DispatchLog } from '@/api/dispatches.api';

export interface DispatchFilters {
  page?: number;
  pageSize?: number;
  status?: DispatchStatus;
  campaignId?: string;
  from?: string;
  to?: string;
}

export function useDispatchesList(filters: DispatchFilters = {}) {
  return useQuery({
    queryKey: ['dispatches', filters],
    queryFn: () => dispatchesApi.list(filters),
    select: (res) => res.data,
  });
}

export function useRetryDispatch() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: dispatchesApi.retry,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['dispatches'] });
      toast.success('Reenvio agendado');
    },
    onError: (err) => toast.error(extractErrorMessage(err)),
  });
}

export function useDispatchLogs(dispatchId: string | null) {
  return useQuery({
    queryKey: ['dispatch-logs', dispatchId],
    queryFn: () => dispatchesApi.getLogs(dispatchId!),
    select: (res) => res.data.data,
    enabled: !!dispatchId,
  });
}

export function useQuickSend() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: dispatchesApi.send,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['dispatches'] });
      toast.success('Mensagem enviada com sucesso');
    },
    onError: (err) => toast.error(extractErrorMessage(err)),
  });
}
